import React from 'react';
import { HoverCard, HoverCardDropdownProps, HoverCardProps, HoverCardTargetProps } from '@mantine/core';

export function EHoverCard({ ...props }: HoverCardProps) {
    return (
        <HoverCard shadow="sm" radius="lg" withArrow arrowSize={10} {...props} />
    );
};

export function EHoverTarget({ ...props }: HoverCardTargetProps) {
    return (
        <HoverCard.Target {...props} />
    );
};

export function EHoverDropdown({ ...props }: HoverCardDropdownProps) {
    return (
        <HoverCard.Dropdown {...props} />
    );
};